// extracted by mini-css-extract-plugin
export default {"audio_controller":"Audio_audio_controller__YCVI+","handle_audio":"Audio_handle_audio__MDzL+","indicator":"Audio_indicator__vobe5"};